import React from "react";
import { IFormikFieldProps } from "../../interfaces/formik/IFormikField";

const TextAreaEditProfile = ({
  sm = 5,
  smLabel = 3,
  hidden = false,
  required = true,
  readonly = false,
  rows = 3,
  label = <></>,
  unclickable = false,
  tooltip = null,
  ...props
}: IFormikFieldProps & {
  label: any;
  unclickable?: boolean;
  rows?: number;
  tooltip?: any;
}) => {
  const error =
    props.formik.touched[props.field] &&
    Boolean(props.formik.errors[props.field]);

  return (
    <React.Fragment>
      <tr>
        <td className={`field`} style={{ color: `${error ? "red" : "black"}`, verticalAlign: "top", paddingTop: "12px" }}>
          {label} :{" "}
        </td>
        <td className="d-flex flex-row align-items-start">
          <div className={`col-md-${sm}`} style={unclickable ? {cursor: 'not-allowed'} : {}}>
            <textarea
              rows={rows}
              className={`form-control mb-5px fs-13px ${
                error ? "is-invalid" : ""
              }`}
              id={props.field}
              name={props.field}
              placeholder={props.placeholder}
              onChange={(event: any) => {
                props.formik.handleChange(event);
              }}
              value={props.formik.values[props.field]}
              readOnly={readonly}
              disabled={props.disabled}
              style={unclickable ? {pointerEvents: 'none', resize: 'vertical'} : {resize: 'vertical'}}
            />
            <div
              className="invalid-feedback"
              style={{
                marginTop: "-1%",
                display: "flex",
                marginLeft: "0.25em",
              }}
            >
              {props.formik.touched[props.field] &&
                props.formik.errors[props.field] && (
                  <>{props.formik.errors[props.field]}</>
                )}
            </div>
          </div>
          {tooltip && (
            <div className="d-flex justify-content-center align-items-center ms-2">
              {tooltip}
            </div>
          )}
        </td>
      </tr>
    </React.Fragment>
  );
};

export default TextAreaEditProfile;

